import { ChangeEvent, useEffect, useRef, useState } from "react";
import { IUser } from "../../type";
import "./index.css";

interface IProps {
  user: IUser;
  onClickRight: (n: Date) => void;
  onClickLeft: () => void;
}
const defaultBirthday = new Date();

export function BirthdateEdit(props: IProps) {
  const dateInputRef = useRef<HTMLInputElement>(null);
  const [date, setDate] = useState<Date>(
    props.user.birthdate || defaultBirthday
  );

  useEffect(() => {
    setDate(props.user.birthdate || defaultBirthday);
  }, [props.user]);

  function handleChangeDate(e: ChangeEvent<HTMLInputElement>) {
    let g = e.target.value; //""
    if (g === "") {
      setDate(props.user.birthdate || defaultBirthday);
    } else {
      setDate(new Date(g));
    }
  }

  const onclkbtn = () => {
    props.onClickRight(date);
  };

  return (
    <section className="section mainPage flex flex-column sectionUser profileEditStep">
      <input
        ref={dateInputRef}
        className="editDataProfileDateInp"
        type="date"
        id="date"
        name="date"
        value={date.toISOString().substring(0, 10)}
        onChange={handleChangeDate}
        min="1930-01-01"
        max={defaultBirthday.toISOString().substring(0, 10)}
        placeholder="Дата"
        required
      />
      <div
        className="editDataProfileDate"
        onClick={() => {
          try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const tg = (window as any).Telegram?.WebApp;
            if (tg?.platform === "android")
              dateInputRef.current?.click();
            else dateInputRef.current?.focus();
          } catch (e) {}
          dateInputRef.current?.click();
        }}
      >
        {date !== defaultBirthday ? (
          date.toLocaleDateString()
        ) : (
          <p className="bitdateplaceholder">Дата рождения</p>
        )}
      </div>

      <div className="conteinerbtn">
        <div
          className="mainContentSurveyLesson-skipButton "
          onClick={() => {
            props.onClickLeft();
          }}
        >
          Назад
        </div>
        <div className="mainContentSurveyLesson-sendButton" onClick={onclkbtn}>
          Далее
        </div>
      </div>
    </section>
  );
}
